var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 293,
    viewBox: "0 0 293 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 24.7262,
    y: 24.726,
    width: 243.548,
    height: 243.548,
    rx: 121.774,
    fill: "white",
    stroke: "#28B882",
    strokeWidth: 14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 7,
    y: 7,
    width: 279,
    height: 279,
    rx: 139.5,
    stroke: "#28B882",
    strokeWidth: 14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4523,
    y: 35.4519,
    width: 222.096,
    height: 222.096,
    rx: 111.048,
    fill: "#28B882"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.556 123.691L132.814 178.433L107.724 153.343L114.157 146.91L132.814 165.523L181.124 117.259L187.556 123.691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessVector);
export default __webpack_public_path__ + "static/media/success_vector.d43df691fb8535cf906351e8f0a6697d.svg";
export { ForwardRef as ReactComponent };